import { TextField, Flex, PhoneNumberField } from "@aws-amplify/ui-react";
import { Controller } from "react-hook-form";
export default function ProfileContactFormContainer({
  control,
  profileContact,
  errors,
  setValue,
  getValues,
}) {
  return (
    <>
      <Flex
        gap="24px"
        direction={{ base: "column", medium: "row" }}
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Controller
          name="profileContact.address1"
          control={control}
          render={({ field }) => (
            <TextField
              minWidth="300px"
              label="*Address line 1"
              {...field}
              value={field.value ?? profileContact?.address1}
              errorMessage={errors.profileContact?.address1?.message}
              hasError={!!errors.profileContact?.address1}
            />
          )}
        />
        <Controller
          name="profileContact.address2"
          control={control}
          render={({ field }) => (
            <TextField
              minWidth="300px"
              label="*Address line 2"
              {...field}
              value={field.value ?? profileContact?.address2}
              errorMessage={errors.profileContact?.address2?.message}
              hasError={!!errors.profileContact?.address2}
            />
          )}
        />
      </Flex>
      <Flex gap="24px" direction={{ base: "column", medium: "row" }} justifyContent="flex-start" alignItems="flex-start">
        <Controller
          name="profileContact.city"
          control={control}
          render={({ field }) => (
            <TextField
              minWidth="300px"
              label="*City"
              {...field}
              value={field.value ?? profileContact?.city}
              errorMessage={errors.profileContact?.city?.message}
              hasError={!!errors.profileContact?.city}
            />
          )}
        />
        <Controller
          name="profileContact.state"
          control={control}
          render={({ field }) => (
            <TextField
              minWidth="300px"
              label="*State"
              {...field}
              value={field.value ?? profileContact?.state}
              errorMessage={errors.profileContact?.state?.message}
              hasError={!!errors.profileContact?.state}
            />
          )}
        />
      </Flex>
      <Controller
        name="profileContact.zip"
        control={control}
        render={({ field }) => (
          <TextField
            minWidth="300px"
            label="*Zip code"
            {...field}
            value={field.value ?? profileContact?.zip}
            errorMessage={errors.profileContact?.zip?.message}
            hasError={!!errors.profileContact?.zip}
          />
        )}
      />
      <Controller
        name="profileContact.primaryPhone"
        control={control}
        render={({ field }) => (
          <PhoneNumberField
            {...field}
            label="*Primary phone"
            defaultDialCode={profileContact?.primaryDialCode ?? "+1"}
            dialCodeName="profileContact.primaryDialCode"
            dialCodeLabel="Dial Code"
            errorMessage={errors.profileContact?.primaryPhone?.message}
            hasError={!!errors.profileContact?.primaryPhone}
            onChange={(e) => {
              const dialCode = getValues("profileContact.primaryDialCode");
              if (!dialCode) {
                setValue("profileContact.primaryDialCode", "+1");
              }
              field.onChange(e.target.value);
            }}
            onDialCodeChange={(e) => {
              setValue("profileContact.primaryDialCode", e.target.value);
            }}
          />
        )}
      />
      <Controller
        name="profileContact.secondaryPhone"
        control={control}
        render={({ field }) => (
          <PhoneNumberField
            {...field}
            label="Secondary phone"
            defaultDialCode={profileContact?.secondaryDialCode ?? "+1"}
            dialCodeName="profileContact.secondaryDialCode"
            dialCodeLabel="Dial Code"
            errorMessage={errors.profileContact?.secondaryPhone?.message}
            hasError={!!errors.profileContact?.secondaryPhone}
            onChange={(e) => {
              const dialCode = getValues("profileContact.secondaryDialCode");
              if (!dialCode) {
                setValue("profileContact.secondaryDialCode", "+1");
              }
              field.onChange(e.target.value);
            }}
            onDialCodeChange={(e) => {
              setValue("profileContact.secondaryDialCode", e.target.value);
            }}
          />
        )}
      />
      <Controller
        name="profileContact.workPhone"
        control={control}
        render={({ field }) => (
          <PhoneNumberField
            {...field}
            label="Work phone"
            defaultDialCode={profileContact?.workDialCode ?? "+1"}
            dialCodeName="profileContact.workDialCode"
            dialCodeLabel="Dial Code"
            errorMessage={errors.profileContact?.workPhone?.message}
            hasError={!!errors.profileContact?.workPhone}
            onChange={(e) => {
              const dialCode = getValues("profileContact.workDialCode");
              if (!dialCode) {
                setValue("profileContact.workDialCode", "+1");
              }
              field.onChange(e.target.value);
            }}
            onDialCodeChange={(e) => {
              setValue("profileContact.workDialCode", e.target.value);
            }}
          />
        )}
      />
    </>
  );
}
